import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import MuiAvatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';

export const drawerWidth = 200;

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  boxShadow: 'none',
  background: 'inherit',
  padding: 'inherit',
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      height: '50px',
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const StyledAccountIconButton = styled(IconButton, {
  name: 'StyledAccountIconButton',
})(() => ({
  padding: '0%',
}));

export const AvatarIcon = styled(MuiAvatar)(() => ({
  width: '44px',
  height: '44px',
  filter: 'drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.2))',
}));

export const SmallAvatarIcon = styled(MuiAvatar)(() => ({
  height: '26px',
  width: '26px',
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  pointerEvents: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  minWidth: '20vw',
}));

export const LargeAvatarIcon = styled(MuiAvatar)(() => ({
  width: '106px',
  height: '106px',
  border: '2px solid #ffffff',
  filter: 'drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.2))',
}));
